<template>
  <li class="nav-group" :class="`${toggled ? 'opened-dropdown': 'closed-dropdown'}`">
    <button class="nav-group-title" @click="toggled = !toggled" id="account-details-button" :aria-expanded="toggled" aria-controls="account-details-expanded">
      <i class="fas fa-address-card" aria-hidden="true"></i><span>Account Details</span>
      <i class="fas fa-angle-down" aria-hidden="true"></i>
    </button>
    <ul id="account-details-expanded" aria-labelledby="account-details-button" :hidden="!toggled">
      <li class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'profile_information' }">
            <span>Profile Information</span>
          </router-link>
        </div>
      </li>
      <li class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'profile_email_address' }">
            <span>Email Addresses</span>
          </router-link>
        </div>
      </li>
      <li class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'profile_password' }">
            <span>Password</span>
          </router-link>
        </div>
      </li>
    </ul>
  </li>
</template>

<style scoped>
.nav-group-title a i {
  color: var(--kate-type-blue);
}

.nav-group {
  list-style: none;
}
</style>

<script>
export default {
  data() {
    return {
      toggled: false,
    };
  },
};
</script>
